// src/config/appConfig.js

const appConfig = {
  companyName: "PT Teknologi Mudah Selaras",
  projectName: "Company Portal with Blogs",
  tagline: "Revolutionizing water quality monitoring for fish ponds using IoT technology.",
  // apiBaseUrl: "http://localhost:3500", // still included for API calls
  apiBaseUrl: "https://backendapi-tmsweb.onrender.com",
  year: new Date().getFullYear(),
  theme: {
    primaryText: "text-teal-700",
    primaryTextHover: "hover:text-teal-900",
    heading: "text-teal-900",
  },
  features: {
    showLoginCta: true,
  },
  content: {
    sections: [
      {
        id: "about",
        title: "About the Project",
        body:
          "FishFlow IoT is an innovative solution designed to monitor water quality in fish ponds using IoT sensors. By providing real-time data on key environmental factors such as pH levels, temperature, and ammonia content, FishFlow IoT helps farmers optimize the conditions for fish growth, ensuring better yield and sustainability."
      },
      {
        id: "mission",
        title: "Our Mission",
        body:
          "At PT Teknologi Mudah Selaras, our mission is to make technology accessible and practical for businesses in various sectors. We believe that the right use of IoT technology can lead to greater efficiency, sustainability, and better results for industries such as aquaculture."
      },
      {
        id: "tech",
        title: "Technologies We Use",
        list: [
          "IoT Sensors for pH, Temperature, and Ammonia Monitoring",
          "ESP32 Microcontroller for real-time data transmission",
          "MQTT Protocol for efficient data communication",
          "React.js for building a modern, responsive front-end",
          "Node.js and Express for backend API development",
          "MongoDB for efficient data storage and management"
        ]
      }
    ],
    cta: { label: "Sign In to Access More Features", to: "/login" },
    backToHome: { label: "Back to Home", to: "/" }
  }
};

export default appConfig;
